import i18nFactory from '@yandex-int/i18n';
import { Image } from 'lego-on-react';
import * as React from 'react';
import { KeyboardEvent } from 'react';

import { Bem } from '../../service/Bem/Bem';
import { KeyCode } from '../../typings/common';
import { ButtonDecorator } from '../ButtonDecorator/ButtonDecorator';
import { TextInputDecorator } from '../TextInputDecorator/TextInputDecorator';

import './Captcha.css';
import * as keyset from './Captcha.i18n';

const i18n = i18nFactory(keyset);

interface CaptchaProps {
    captchaUrl: string;
    onSubmit: (value: string) => void;
}

interface CaptchaState {
    value: string;
}

export class Captcha extends React.Component<CaptchaProps, CaptchaState> {
    constructor(props: CaptchaProps) {
        super(props);

        this.state = {
            value: ''
        };
    }

    render() {
        const { captchaUrl } = this.props;
        const { value } = this.state;
        return (
            <div className={Bem.cls('captcha')}>
                <div className={Bem.cls('captcha', 'title')}>{i18n('robot-ne-smozhet-vvesti')}</div>
                <div className={Bem.cls('captcha', 'image')}>
                    <Image url={captchaUrl} width={200} />
                </div>
                <div className={Bem.cls('captcha', 'controls')}>
                    <TextInputDecorator
                        cls={Bem.cls('captcha', 'control')}
                        text={value}
                        theme={'normal'}
                        view={'classic'}
                        size={'n'}
                        placeholder={i18n('vvedite-simvoly-s-kartinki')}
                        onChange={this.onChange}
                        onKeyDown={this.onKeyDown}
                    />
                    <ButtonDecorator
                        cls={Bem.cls('captcha', 'control')}
                        theme={'action'}
                        size={'n'}
                        text={i18n('send')}
                        onClick={this.onSubmit}
                    />
                </div>
            </div>
        );
    }

    private onChange = (value: string) => this.setState({ value });

    private onSubmit = () => this.props.onSubmit(this.state.value);

    private onKeyDown = (e: KeyboardEvent<HTMLDivElement>) => {
        if (e.keyCode === KeyCode.RETURN) {
            this.props.onSubmit(this.state.value);
        }
    };
}
